import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconComponent, TooltipDirective } from '@mode/capra';
import { SwitchViewsDomainModule } from '@mode/switch-views/domain';
import { ContextMenuModule } from '@perfectmemory/ngx-contextmenu';
import { DndModule } from 'ngx-drag-drop';
import { FieldListAttrComponent } from './field-list-attr/field-list-attr.component';
import { FieldListToolbarComponent } from './field-list-toolbar/field-list-toolbar.component';
import { FieldListComponent } from './field-list/field-list.component';
@NgModule({
  imports: [
    CommonModule,
    ContextMenuModule.forRoot(),
    DndModule,
    IconComponent,
    TooltipDirective,
    FieldListToolbarComponent,
    SwitchViewsDomainModule,
  ],
  declarations: [FieldListComponent, FieldListAttrComponent],
  exports: [FieldListComponent],
})
export class SwitchViewsFeatureFieldlistModule {}
